/**
 * `INTERACTION_PREVIEWS` — the read-only twin of `INTERACTION_EDITORS`, kept the same shape on
 * purpose: a seventh interaction type then fails both compile checks in the same breath.
 *
 * `Record<InteractionType, Component>` is exhaustive — not `Partial`, no index signature — where a
 * `v-if` chain would let a new type render nothing and say nothing about it.
 *
 * Every preview takes the same single prop (`InteractionPreviewProps`), deliberately narrower than
 * the editors': a read-only renderer is not handed the ids it would need in order to mutate.
 */
import type { Component } from 'vue'
import type { InteractionType } from '../../../../model/assessments/types'

import PreviewMultipleChoice from './PreviewMultipleChoice.vue'
import PreviewFillInBlanks from './PreviewFillInBlanks.vue'
import PreviewDragTheWords from './PreviewDragTheWords.vue'
import PreviewWhiteboard from './PreviewWhiteboard.vue'
import PreviewOpenEnded from './PreviewOpenEnded.vue'
import PreviewAudioResponse from './PreviewAudioResponse.vue'

export const INTERACTION_PREVIEWS: Record<InteractionType, Component> = {
  multiple_choice: PreviewMultipleChoice,
  fill_in_blanks: PreviewFillInBlanks,
  drag_the_words: PreviewDragTheWords,
  whiteboard: PreviewWhiteboard,
  open_ended: PreviewOpenEnded,
  audio_response: PreviewAudioResponse,
}
